// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cpSS","footer":"styles_footer__2fjTD","passCodeTooltip":"styles_passCodeTooltip__6MNAH"};